<template>
  <div class="container">
    <div class="row">
      <b-link
        class="font-weight-bold d-block text-nowrap mr-3 mb-2"
        @click="mudarComponente()"
      >
        <el-button
          id="voltar-lista-aluno"
          style="border: none; background-color: transparent;"
          type="button"
          class="is-plain"
        >
          <i class="el-icon-back" />
          Cursos
        </el-button>
      </b-link>
      <div
        v-if="conteudoExist === 0"
        class="card col-12"
      >
        <div class="d-flex align-content-center justify-content-center">
          <img
            class="my-3"
            width="300px"
            src="https://dkplayer.s3.sa-east-1.amazonaws.com/Paulo_Henrique-Id344/icone-nada.jpg"
          >
        </div>
        <div>
          <h3 class="text-center mb-5">
            Esse curso nao possui modulos cadastrados.
          </h3>
        </div>
      </div>

      <div
        v-if="conteudoExist === 1"
        class="col-md-9"
      >
        <div class="card p-3">
          <h3>Progresso Geral</h3>
          <div class="progress-wrapper mt-1 mb-3">
            <b-card-text class="mb-0">
              {{ progresso +'%' }}
            </b-card-text>
            <b-progress
              v-model="progresso"
              max="100"
            />
          </div>
          <div v-show="videoAparece">
            <video
              ref="videoPlayer"
              controls
              style="width: 100%; height: 500px;"
              :src="moduloAtual.video_url"
              type="video/mp4"
            />
          </div>
          <div>
            <header class="flex items-center justify-between py-1 px-4 lg:px-6 lg:border-b border-b-0">
              <div>
                <h3
                  class="lg:text-2xl text-xl line-clamp"
                  style="color: rgb(35, 83, 255);"
                >
                  {{ moduloAtual.titulo }}
                </h3></div>
              <div class="flex items-center flex-shrink-0 flex-grow-0">
                <div class="mr-4">
                  <div class="flex items-center" />
                </div>
              </div>
            </header>

            <div class="flex items-center justify-between py-1 px-4 lg:px-6 lg:border-b border-b-0">
              <div class="mt-8 mb-8 px-8"><!---->
                <div
                  class="prose-sm prose-non-premium prose lg:prose-lg w-full"
                  style="max-width: 100% !important;"
                >
                  <p v-html="moduloAtual.content" /></div>
              </div>
              <b-card
                id="anexo-arquivos-conteudo"
                class="custom-card"
              >
                <b-card-code
                  v-if="conteudoExist === 1"
                  title="Arquivos para baixar"
                />
                <Pastas
                  v-model="pastas"
                  @updateArquivos="getArquivosByFolder($event)"
                />
                <arquivos
                  v-model="arquivos"
                  @updatedArquivos="getArquivosByFolder($event)"
                />
              </b-card>
            </div>

          </div>
        </div>
      </div>
      <!--        <pre>{{ modulos }}</pre>-->
      <div
        v-if="conteudoExist === 1"
        class="col-md-3"
      >
        <div
          v-for="(module, index) in modulos"
          :key="index"
          class="card no-gutters "
        >
          <div class="row justify-content-center input-container">
            <div class="d-flex align-items-center">
              <div
                class="flex-grow-1"
                style="margin-right: 25px;"
              >

                <h2><strong>{{ module.modulo_name }}</strong></h2>
              </div>
            </div>
          </div>
          <button
            class="collapsible"
            data-bs-toggle="collapse"
            :data-bs-target="`#collapse_${module.id}`"
            :aria-expanded="index === 0 ? 'true' : 'false'"
            :aria-controls="`collapse_${index}`"
          />
          <div
            v-for="(content, contentIndex) in module.conteudo"
            :id="`collapse_${module.id}`"
            :key="contentIndex"
            :class="{ show: index === 0, 'bg-light': content.id === moduloAtual.id }"
            class="content d-flex align-items-center"
            :style="{ maxHeight: '100%', cursor: 'pointer' }"
            @click="videoUrl(content)"
          >
            <div class="row full-width p-1 m-0">
              <div class="col-8">
                <h4>{{ content.titulo }}</h4>
              </div>
              <div class="col">
                <el-progress
                  type="circle"
                  :width="40"
                  :percentage="content.progresso_conteudo"
                  :status="content.progresso_conteudo === 100 ? 'success' : ''"
                />
              </div>
              <div class="col-12">
                <p
                  v-if="content.id === moduloAtual.id"
                  class="font-weight-bold text-underlined"
                >
                  Você está aqui
                </p>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ChatBoosterTreinamento from '@/views/App/Treinamentos/Chat/ChatBoosterTreinamento.vue'

import { ModuloService } from '@/services/Modulo'
import { useApi } from '@/composables/useApi'
import axios from 'axios'
import Pastas from '@/views/App/Cursos/AreaAluno/PastasAluno.vue'
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import Arquivos from '@/views/App/Cursos/AreaAluno/FilesAluno.vue'

const moduloService = new ModuloService()
const apiBack = useApi()
export default {
  components: {
    Arquivos,
    BCardCode,
    Pastas,
    ChatBoosterTreinamento,
  },
  data() {
    return {
      estatisticas: [],
      qtd_plays: 0,
      progresso: '',
      conteudoExist: 1,
      moduloAtual: {},
      cursoId: this.$route.params.id,
      modulosConteudos: {},
      modulos: [],
      embedCode: '',
      videoAparece: true,
      videoElement: null,
      pastas: [],
      startTime: 10,
      arquivos: [],
    }
  },
  computed: {
    idUser() {
      return JSON.parse(localStorage.getItem('userData')).id
    },
  },
  beforeMount() {
    this.modulosConteudos = {}
  },
  async mounted() {
    await this.buscarModulo()
    await this.addEventVideo()
    await this.buscarStatics()
    await this.getFoldersAll()
    await this.setFolderATUAL()
    await this.getArquivosAll()
  },
  async beforeDestroy() {
    // console.log('Segundos Assistidos.', this.videoElement.currentTime.toFixed(0))
    // console.log('Porcentagem do vídeo assistido:', this.videoElement.percentualAssistido)
    // console.log('Quantidade de plays', this.qtd_plays)
    // console.log('Id Aluno', this.idUser)
    // console.log('Id Curso', this.cursoId)
    // console.log('Uid Conteudo', this.moduloAtual.uid)
    if (this.videoElement === undefined) {
      await apiBack.post('/AtualizarDadosProgresso', {
        id_aluno: this.idUser,
        id_curso: this.cursoId,
        uid_conteudo: this.moduloAtual.uid,
        qtd_plays: this.qtd_plays,
        tempo_assistido: 0,
        progresso_conteudo: 0,
      })
        .then(() => {
        })
        .catch(err => console.error(err))
    } else {
      await apiBack.post('/AtualizarDadosProgresso', {
        id_aluno: this.idUser,
        id_curso: this.cursoId,
        uid_conteudo: this.moduloAtual.uid,
        qtd_plays: this.qtd_plays,
        tempo_assistido: this.videoElement.currentTime.toFixed(0),
        progresso_conteudo: this.videoElement.percentualAssistido,
      })
        .then(() => {
        })
        .catch(err => console.error(err))
    }
    if (this.videoElement) {
      this.videoElement.removeEventListener('timeupdate', this.trackVideoProgress)
    }
  },
  methods: {
    async videoUrl(content) {
      if (this.videoElement === undefined) {
        await apiBack.post('/AtualizarDadosProgresso', {
          id_aluno: this.idUser,
          id_curso: this.cursoId,
          uid_conteudo: this.moduloAtual.uid,
          qtd_plays: this.qtd_plays,
          tempo_assistido: 0,
          progresso_conteudo: 100,
        })
          .then(() => {
          })
          .catch(err => console.error(err))
      } else {
        console.log('Segundos Assistidos.', this.videoElement.currentTime.toFixed(0))
        console.log('Porcentagem do vídeo assistido:', this.videoElement.percentualAssistido)
        console.log('Quantidade de plays', this.qtd_plays)
        console.log('Id Aluno', this.idUser)
        console.log('Id Curso', this.cursoId)
        console.log('Uid Conteudo', this.moduloAtual.uid)
        await apiBack.post('/AtualizarDadosProgresso', {
          id_aluno: this.idUser,
          id_curso: this.cursoId,
          uid_conteudo: this.moduloAtual.uid,
          qtd_plays: this.qtd_plays,
          tempo_assistido: this.videoElement.currentTime.toFixed(0),
          progresso_conteudo: this.videoElement.percentualAssistido,
        })
          .then(() => {
          })
          .catch(err => console.error(err))
      }
      this.moduloAtual = content
      if (this.moduloAtual.status_video === 0) {
        this.videoAparece = false
      } else {
        this.videoAparece = true
      }
      await this.getFoldersAll()
      await this.getArquivosAll()
      await this.atualizarModulos()
    },
    async buscarModulo() {
      await apiBack.post(`/getEstatisticasByAluno?id_aluno=${this.idUser}&id_curso=${this.cursoId}`)
        .then(data => {
          this.estatisticas = data.data
        })
        .catch(err => console.error(err))
      await apiBack.get(`/getModuloByIdCursoController?id_curso=${this.cursoId}`)
        .then(data => {
          this.modulos = data.data
          for (const modulo of this.modulos) {
            for (const conteudo of modulo.conteudo) {
              conteudo.progresso_conteudo = 0 // Adicionar o campo progresso_conteudo
              conteudo.tempo_assistido = 0 // Adicionar o campo tempo_assistido
              const estatistica = this.estatisticas.find(
                item => item.uid_conteudo === conteudo.uid.replace(/^0+/, ''),
              )
              if (estatistica) {
                conteudo.progresso_conteudo = estatistica.progresso_conteudo
                conteudo.tempo_assistido = estatistica.tempo_assistido
              }
            }
          }
          let primeiroConteudoIncompleto
          for (const modulo of this.modulos) {
            for (const conteudo of modulo.conteudo) {
              if (conteudo.progresso_conteudo !== 100) {
                primeiroConteudoIncompleto = conteudo
                break
              }
            }
            if (primeiroConteudoIncompleto) {
              break
            }
          }
          this.moduloAtual = primeiroConteudoIncompleto || this.modulos[0].conteudo[0]
          if (this.moduloAtual.status_video === 0) {
            this.videoAparece = false
          }
          console.log()
        })
        .catch(err => console.error(err))
    },
    addEventVideo() {
      this.videoElement = this.$refs.videoPlayer
      if (this.videoElement) {
        this.videoElement.addEventListener('timeupdate', this.trackVideoProgress)
        this.videoElement.addEventListener('play', this.trackVideoPlay)
        this.videoElement.addEventListener('loadedmetadata', () => {
          console.log('MODULOATUAL', this.moduloAtual)
          this.$refs.videoPlayer.currentTime = this.moduloAtual.tempo_assistido
        })
      }
    },
    async atualizarModulos() {
      await apiBack.post(`/getEstatisticasByAluno?id_aluno=${this.idUser}&id_curso=${this.cursoId}`)
        .then(data => {
          this.estatisticas = data.data
        })
        .catch(err => console.error(err))
      await apiBack.get(`/getModuloByIdCursoController?id_curso=${this.cursoId}`)
        .then(data => {
          this.modulos = data.data
          for (const modulo of this.modulos) {
            for (const conteudo of modulo.conteudo) {
              conteudo.progresso_conteudo = 0 // Adicionar o campo progresso_conteudo
              conteudo.tempo_assistido = 0 // Adicionar o campo tempo_assistido
              const estatistica = this.estatisticas.find(
                item => item.uid_conteudo === conteudo.uid.replace(/^0+/, ''),
              )
              if (estatistica) {
                conteudo.progresso_conteudo = estatistica.progresso_conteudo
                conteudo.tempo_assistido = estatistica.tempo_assistido
              }
            }
          }
        })
    },
    trackVideoPlay() {
      this.qtd_plays++
    },
    trackVideoProgress() {
      if (this.videoElement) {
        const { currentTime } = this.videoElement
        const { duration } = this.videoElement

        if (!isNaN(currentTime) && !isNaN(duration)) {
          const percentageWatched = (currentTime / duration) * 100
          this.videoElement.percentualAssistido = percentageWatched.toFixed(0)
        }
      }
    },
    forceFileDownload(response, fileName) {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()
    },
    async buscarStatics() {
      await apiBack.get(`/getAlunoProgresso?id_aluno=${this.idUser}&id_curso=${this.cursoId}`)
        .then(data => {
          this.progresso = data.data[0].progress
        })
        .catch(err => console.error(err))
    },
    async getArquivosAll() {
      const id_conteudo = localStorage.getItem('uidConteudo')
      if (id_conteudo === undefined) {
        this.conteudoExist = 0
      } else {
        const params = {
          id_main: 0,
          id_conteudo,
        }
        await apiBack.get('/arquivoUser', {
          params,
        })
          .then(resp => {
            const formData = resp.data
            formData.map(f => f.is_selected = false)
            this.arquivos = formData
          })
      }
    },
    async getArquivosByFolder(event) {
      const { id } = event
      const id_conteudo = localStorage.getItem('uidConteudo')
      const params = {
        id_main: id,
        id_conteudo,
      }
      await apiBack.get('/arquivoUser', {
        params,
      })
        .then(resp => {
          const formData = resp.data
          formData.map(f => f.is_selected = false)
          this.arquivos = formData
        })
    },
    async getFoldersAll() {
      localStorage.setItem('uidConteudo', this.moduloAtual.uid)
      const idConteudo = localStorage.getItem('uidConteudo')
      if (idConteudo === 'undefined') {
        this.conteudoExist = 0
      } else {
        const params = {
          id_main: 0,
          id_conteudo: this.moduloAtual.uid,
        }
        await apiBack.get('/pastaUser', {
          params,
        })
          .then(resp => {
            const formData = resp.data
            formData.map(f => f.is_selected = false)
            this.pastas = formData
          })
      }
    },
    setFolderATUAL() {
      const atual = 0
      localStorage.setItem('pastaATUAL', JSON.stringify(atual))
    },
    download(item) {
      axios({
        method: 'get',
        url: item.file_bucket_address,
        responseType: 'arraybuffer',
      })
        .then(response => {
          this.forceFileDownload(response, item.file_name)
        })
        .catch(() => console.log('error occured'))
    },
    async mudarComponente() {
      if (this.videoElement === undefined) {
        await apiBack.post('/AtualizarDadosProgresso', {
          id_aluno: this.idUser,
          id_curso: this.cursoId,
          uid_conteudo: this.moduloAtual.uid,
          qtd_plays: this.qtd_plays,
          tempo_assistido: 0,
          progresso_conteudo: 0,
        })
          .then(() => this.$router.push('/courses'))
          .catch(err => console.error(err))
      } else {
        await apiBack.post('/AtualizarDadosProgresso', {
          id_aluno: this.idUser,
          id_curso: this.cursoId,
          uid_conteudo: this.moduloAtual.uid,
          qtd_plays: this.qtd_plays,
          tempo_assistido: this.videoElement.currentTime.toFixed(0),
          progresso_conteudo: this.videoElement.percentualAssistido,
        })
          .then(() => this.$router.push('/courses'))
          .catch(err => console.error(err))
      }
    },
  },
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/cardfile.scss';
@import "@/assets/scss/vslTreinamento.scss";
.text-underlined {
  text-decoration: underline;
}

</style>
